import React from "react";
import { Datacenter, datadogLogs } from "@datadog/browser-logs";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import { hydrate } from "react-dom";
import { MarketingAppContainer } from "./containers/MarketingAppContainer/MarketingAppContainer";
import * as MarketingView from "../../domain/models/MarketingView";

declare const window: Window & { __MARKETING__?: MarketingView.T };

const start = (): void => {
    datadogLogs.init({
        clientToken: (env.REACT_APP_DATADOG_CLIENT_TOKEN || ""),
        forwardErrorsToLogs: true,
        datacenter: Datacenter.EU,
        sampleRate: 100,
    });

    const view = window.__MARKETING__;

    if (!view) {
        return;
    }

    hydrate(
        <MarketingAppContainer view={view} />,
        document.getElementById("app"),
    );
};

start();
